import {
  Flex,
  Chip,
  Divider,
  Text,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
} from '@shared/components';

interface ExamRoomCardProps {
  orderNumber: number;
  floor: string;
  roomName: string;
  roomNumber: string;
  seatCount: number;
  menuOptions?: MoreMenuIconButtonOption[];
}

export default function ExamRoomCard(props: Readonly<ExamRoomCardProps>) {
  const { orderNumber, floor, roomName, roomNumber, seatCount, menuOptions = [] } = props;

  return (
    <Flex
      sx={(theme) => ({
        border: '1px solid ' + theme.palette.divider,
        borderRadius: theme.shape.borderRadius,
        p: theme.spacing(3),
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '84px',
      })}
    >
      <Flex
        sx={{
          alignItems: 'center',
          flex: 1,
          overflow: 'hidden',
        }}
        gap={3}
      >
        <Chip
          label={`ห้องสอบที่ ${orderNumber}`}
          size='small'
          sx={(theme) => ({
            backgroundColor: theme.palette.grey[800],
            color: theme.palette.common.white,
            fontWeight: 600,
            px: 2,
            py: 0.5,
            borderRadius: 50,
          })}
        />
        <Divider orientation='vertical' flexItem />
        <Flex gap={4} sx={{ flexWrap: 'wrap', alignItems: 'center' }}>
          <InfoItem label='ชั้น' value={floor} />
          <InfoItem label='ห้อง' value={roomName || '-'} />
          <InfoItem label='เลขที่ห้อง' value={roomNumber || '-'} />
          <InfoItem label='จำนวน' value={`${seatCount} ที่นั่ง`} />
        </Flex>
      </Flex>

      {menuOptions.length > 0 ? (
        <MoreMenuIconButton
          options={menuOptions}
          slotProps={{
            iconButton: { size: 'small' },
            menu: { elevation: 2 },
          }}
        />
      ) : null}
    </Flex>
  );
}

function InfoItem(props: { label: string; value: string }) {
  const { label, value } = props;
  return (
    <Flex gap={1} sx={{ alignItems: 'baseline' }}>
      <Text variant='body2Semibold'>{label}:</Text>
      <Text variant='body2'>{value}</Text>
    </Flex>
  );
}
